import React from 'react'

const StepsIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#C4C4C4" />
      </mask>
      <path
        d="M7.70359 1.86893L7.70402 1.86874C9.05124 1.28778 10.4866 1 12 1C13.5134 1 14.9488 1.28778 16.296 1.86874L16.2964 1.86893C17.6242 2.44223 18.7891 3.22491 19.7821 4.21789C20.7751 5.21087 21.5574 6.37582 22.1301 7.70359C22.7118 9.05091 23 10.4864 23 12C23 13.5136 22.7118 14.9491 22.1301 16.2964C21.5574 17.6242 20.7751 18.7891 19.7821 19.7821C18.7891 20.7751 17.6242 21.5574 16.2964 22.1301C14.9491 22.7118 13.5136 23 12 23C10.4864 23 9.05091 22.7118 7.70359 22.1301C6.37582 21.5574 5.21087 20.7751 4.21789 19.7821C3.22492 18.7891 2.44257 17.6242 1.86993 16.2964C1.28818 14.9491 1 13.5136 1 12C1 10.4866 1.28812 9.05121 1.86974 7.70402L7.70359 1.86893ZM7.70359 1.86893C6.37582 2.44223 5.21087 3.22491 4.21789 4.21789C3.22492 5.21086 2.44257 6.37582 1.86993 7.70359L7.70359 1.86893Z"
        fill="white"
        stroke="#2D42C1"
        strokeWidth="2"
      />
      <circle cx="12.0013" cy="12.6668" r="3.33333" fill="#3249D7" />
      <path
        d="M6.66797 12.6668C6.66797 15.6123 9.05578 18.0002 12.0013 18.0002C14.9468 18.0002 17.3346 15.6123 17.3346 12.6668C17.3346 9.72131 14.9468 7.3335 12.0013 7.3335"
        stroke="#3249D7"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default StepsIcon
